import config from '@/config'

export default {
	id: 'SIMPLE_PREMIUM_1M_38_95_1W_6_93_EN_CLUSTER',
	providers: {
		stripe: config('stripe_cheap_and_short'),
		braintree: 'pro_short_cheap',
		paltaMap: {
			USD: 'simple_premium_1m_38_95_1w_6_93_usd',
			GBP: 'simple_premium_1m_38_95_1w_6_93_gbp',
			CAD: 'simple_premium_1m_49_99_1w_7_99_cad',
			AUD: 'simple_premium_1m_49_99_1w_8_99_aud',
		},
		primer: 'prd_n0RfXgMBId7f',
	},
	model: {
		commitment_period: 0,
		intro_period_value: 1,
		intro_period_type: 'week',
		next_period_value: 1,
		next_period_type: 'month',
	},
	trial: {
		days: 7,
		priceMap: {
			USD: 6.93,
			GBP: 6.93,
			CAD: 7.99,
			AUD: 8.99,
		},
		originalPriceMap: {
			USD: 17.77,
			GBP: 17.77,
			CAD: 25.62,
			AUD: 28.18,
		},
	},
	subscription: {
		interval: 'month',
		intervalCount: 1,
		priceMap: {
			USD: 38.95,
			GBP: 38.95,
			CAD: 49.99,
			AUD: 49.99,
		},
	},
	options: ($t) => ({
		explicitTermsPeriodText: $t('female_yoga.pages.paywall.plans.1_week.into_period_text'), // '7-days'
		explicitTermsIntervalText: $t('female_yoga.pages.paywall.plans.1_week.period_text'), // 'month'
		billingSubtitlePeriodText: $t('female_yoga.pages.paywall.plans.1_week.billing_period_text'), // 'first week'
		footerPeriodText: $t('female_yoga.pages.paywall.plans.1_week.footer_period_text'), // '1-week'
		footerIntervalText: $t('pages.program.cheap_and_short.plans.7_days.sub_period_text'), // 'monthly',
	}),
}
